import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { UpgradeButtonComponent } from '../upgrade-button/upgrade-button.component';

export interface UpgradeCardColumn {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'la-upgrade-card',
  imports: [MatCardModule, MatIconModule, UpgradeButtonComponent],
  templateUrl: './upgrade-card.component.html',
  styleUrl: './upgrade-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeCardComponent {
  @Input() header!: string;
  @Input() columns?: UpgradeCardColumn[];
  @Input() bodyText?: string;
  @Input() canUpgrade = false;
  @Input() buttonText = 'Upgrade';
  @Input() buttonLink?: string[] = ['/account/subscription/upgrade'];
  @Input() isEmptyState = false;

  @Output() action = new EventEmitter<void>();
}
